class Modal {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.modalElem = self.elem.querySelector('[data-modal]');
        self.toggleElems = self.elem.querySelectorAll('[data-modal-toggle]');


    }

    init() {
        let self = this;

        self.createListeners(self);
    }

    createListeners(self) {
        document.addEventListener('DOMContentLoaded', function () {

            self.toggleElems.forEach(function (toggleElem) {
                toggleElem.addEventListener('click', function () {
                    self.modalElem.classList.add("is-active");
                });
            });

            document.addEventListener('click', function (event) {
                // Check if the click is outside the modal
                if (!self.modalElem.contains(event.target) && !event.target.closest('[data-modal-toggle]')) {
                    self.modalElem.classList.remove("is-active");
                }
            });
        });
    }
}

export default Modal;
